module.exports = __webpack_public_path__ + "static/media/step2desktop.6b960460.png";